var _linearGradient, _path, _linearGradient2, _path2, _linearGradient3, _path3, _linearGradient4, _path4, _linearGradient5, _path5, _linearGradient6, _path6, _linearGradient7, _path7, _linearGradient8, _path8, _path9;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgOpco2I(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 161.6 247.9",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _linearGradient || (_linearGradient = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_1_",
    gradientUnits: "userSpaceOnUse",
    x1: -49.238,
    y1: 10.71,
    x2: 54.582,
    y2: 258.53,
    gradientTransform: "matrix(1 0 0 -1 0 250.001)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#1f3765"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.06,
    stopColor: "#283564"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.15,
    stopColor: "#423063"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.28,
    stopColor: "#6b2861"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.42,
    stopColor: "#a41d5e"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.52,
    stopColor: "#d3145b"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.99,
    stopColor: "#f29222"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M49.5 34.9c0 7.3-5.9 13.1-13.1 13.2S23.3 42.2 23.2 35s5.9-13.1 13.1-13.2c7.3 0 13.2 5.9 13.2 13.1zm-3.5 0c0-5.3-4.3-9.6-9.6-9.5-5.3 0-9.6 4.3-9.5 9.6 0 5.3 4.3 9.6 9.6 9.5 5.2 0 9.5-4.3 9.5-9.6z",
    fill: "url(#SVGID_1_)"
  })), _linearGradient2 || (_linearGradient2 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_2_",
    gradientUnits: "userSpaceOnUse",
    x1: -23.762,
    y1: 0.041,
    x2: 80.058,
    y2: 247.861,
    gradientTransform: "matrix(1 0 0 -1 0 250.001)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#1f3765"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.06,
    stopColor: "#283564"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.15,
    stopColor: "#423063"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.28,
    stopColor: "#6b2861"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.42,
    stopColor: "#a41d5e"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.52,
    stopColor: "#d3145b"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.99,
    stopColor: "#f29222"
  }))), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M53.2 51.7V34.9c0-7.2 5.9-13.1 13.1-13.1 7.2 0 13.1 5.9 13.1 13.1S73.5 48.1 66.3 48c-3.6 0-7-1.5-9.5-4.1v7.7l-3.6.1zm13.1-7.2c5.3 0 9.6-4.3 9.6-9.6s-4.3-9.6-9.6-9.6-9.6 4.3-9.6 9.6c.1 5.3 4.3 9.6 9.6 9.6z",
    fill: "url(#SVGID_2_)"
  })), _linearGradient3 || (_linearGradient3 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_3_",
    gradientUnits: "userSpaceOnUse",
    x1: 27.179,
    y1: -21.298,
    x2: 130.999,
    y2: 226.512,
    gradientTransform: "matrix(1 0 0 -1 0 250.001)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#1f3765"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.06,
    stopColor: "#283564"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.15,
    stopColor: "#423063"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.28,
    stopColor: "#6b2861"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.42,
    stopColor: "#a41d5e"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.52,
    stopColor: "#d3145b"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.99,
    stopColor: "#f29222"
  }))), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M139.4 34.9c0 7.3-5.9 13.1-13.1 13.2-7.3 0-13.1-5.9-13.2-13.1s5.9-13.1 13.1-13.2c7.3 0 13.1 5.9 13.2 13.1zm-3.6 0c0-5.3-4.3-9.6-9.6-9.5-5.3 0-9.6 4.3-9.5 9.6 0 5.3 4.3 9.6 9.6 9.5 5.2 0 9.5-4.3 9.5-9.6z",
    fill: "url(#SVGID_3_)"
  })), _linearGradient4 || (_linearGradient4 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_4_",
    gradientUnits: "userSpaceOnUse",
    x1: 8.157,
    y1: -13.323,
    x2: 111.967,
    y2: 234.487,
    gradientTransform: "matrix(1 0 0 -1 0 250.001)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#1f3765"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.06,
    stopColor: "#283564"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.15,
    stopColor: "#423063"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.28,
    stopColor: "#6b2861"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.42,
    stopColor: "#a41d5e"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.52,
    stopColor: "#d3145b"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.99,
    stopColor: "#f29222"
  }))), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M24.2 182v-14.5l42.9-40.2c9-8.4 15.1-16.9 15.1-26.7 0-12.9-7.1-22.4-20.4-22.4-12.9 0-20.6 9.3-20.6 23.7v1.6H24.4v-1.6c0-23.8 14.2-39.5 37.5-39.5 23.1 0 37.5 16.3 37.5 38.2 0 15.4-7.3 25.3-19.9 36.8l-31.6 29v.4h50V182H24.2z",
    fill: "url(#SVGID_4_)"
  })), _linearGradient5 || (_linearGradient5 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_5_",
    gradientUnits: "userSpaceOnUse",
    x1: 12.919,
    y1: -15.318,
    x2: 116.729,
    y2: 232.492,
    gradientTransform: "matrix(1 0 0 -1 0 250.001)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#1f3765"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.06,
    stopColor: "#283564"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.15,
    stopColor: "#423063"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.28,
    stopColor: "#6b2861"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.42,
    stopColor: "#a41d5e"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.52,
    stopColor: "#d3145b"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.99,
    stopColor: "#f29222"
  }))), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M158.3 204.6H4.1c-1.6 0-2.8-1.3-2.8-2.8V2.8C1.2 1.3 2.5 0 4.1 0h154.3c1.6 0 2.9 1.3 2.9 2.8v198.9c-.1 1.7-1.4 2.9-3 2.9zM6.9 198.9h148.6V5.7H6.9v193.2z",
    fill: "url(#SVGID_5_)"
  })), _linearGradient6 || (_linearGradient6 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_6_",
    gradientUnits: "userSpaceOnUse",
    x1: 1.78,
    y1: -10.653,
    x2: 105.6,
    y2: 237.157,
    gradientTransform: "matrix(1 0 0 -1 0 250.001)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#1f3765"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.06,
    stopColor: "#283564"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.15,
    stopColor: "#423063"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.28,
    stopColor: "#6b2861"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.42,
    stopColor: "#a41d5e"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.52,
    stopColor: "#d3145b"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.99,
    stopColor: "#f29222"
  }))), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M96.4 44.5c-5.3 0-9.6-4.3-9.6-9.6s4.3-9.6 9.6-9.6c4.3 0 8.1 2.9 9.2 7h3.7c-1.5-7.1-8.4-11.7-15.5-10.3S82 30.5 83.4 37.6 91.8 49.3 99 47.9c5.2-1.1 9.2-5.1 10.3-10.3h-3.7c-1.2 4.1-5 6.9-9.2 6.9z",
    fill: "url(#SVGID_6_)"
  })), _linearGradient7 || (_linearGradient7 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_7_",
    gradientUnits: "userSpaceOnUse",
    x1: 41.736,
    y1: -27.397,
    x2: 145.556,
    y2: 220.423,
    gradientTransform: "matrix(1 0 0 -1 0 250.001)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#1f3765"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.06,
    stopColor: "#283564"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.15,
    stopColor: "#423063"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.28,
    stopColor: "#6b2861"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.42,
    stopColor: "#a41d5e"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.52,
    stopColor: "#d3145b"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.99,
    stopColor: "#f29222"
  }))), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#SVGID_7_)",
    d: "M117.8 64.7h18.3v18.4h-18.3z"
  })), _linearGradient8 || (_linearGradient8 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_8_",
    gradientUnits: "userSpaceOnUse",
    x1: 63.697,
    y1: -36.588,
    x2: 167.507,
    y2: 211.222,
    gradientTransform: "matrix(1 0 0 -1 0 250.001)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#1f3765"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.06,
    stopColor: "#283564"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.15,
    stopColor: "#423063"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.28,
    stopColor: "#6b2861"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.42,
    stopColor: "#a41d5e"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.52,
    stopColor: "#d3145b"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.99,
    stopColor: "#f29222"
  }))), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#SVGID_8_)",
    d: "M117.8 89.1h18.3V182h-18.3z"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M9.5 217.8c-.1-.3-.2-.7-.4-1-.2-.3-.4-.6-.7-.8-.3-.2-.6-.4-.9-.5-.4-.1-.8-.2-1.3-.2-.6 0-1.2.1-1.8.4-.5.3-.9.7-1.2 1.1-.3.5-.6 1-.7 1.6-.2.6-.2 1.2-.2 1.8 0 .6.1 1.2.2 1.8.1.6.4 1.1.7 1.6.3.5.7.9 1.2 1.1.6.3 1.2.4 1.8.4.5 0 .9-.1 1.3-.3.4-.2.7-.4 1-.7.3-.3.5-.7.6-1.1.2-.4.3-.9.3-1.3h2.2c0 .7-.2 1.5-.5 2.1-.3.6-.7 1.2-1.1 1.7-.5.5-1.1.8-1.7 1.1-.6.3-1.3.4-2.1.4-.9 0-1.8-.2-2.6-.5s-1.4-.8-2-1.5c-.5-.6-1-1.4-1.2-2.2-.3-.8-.4-1.7-.4-2.6 0-.9.1-1.8.4-2.6.3-.8.7-1.5 1.2-2.2.6-.6 1.2-1.1 2-1.5.8-.4 1.7-.6 2.6-.6.7 0 1.4.1 2.1.3.6.2 1.2.5 1.7.9s.9.9 1.2 1.4c.3.6.5 1.2.6 1.9H9.5zm12.3-4.4c.9 0 1.8.2 2.6.6.8.3 1.4.9 2 1.5.5.6 1 1.4 1.2 2.2.3.8.4 1.7.4 2.6 0 .9-.1 1.8-.4 2.6-.3.8-.7 1.5-1.3 2.2-.6.6-1.2 1.1-2 1.5-1.7.7-3.6.7-5.2 0-.8-.3-1.4-.8-2-1.5-.5-.6-.9-1.4-1.1-2.2-.3-.9-.4-1.7-.4-2.6 0-.9.1-1.8.4-2.6.3-.8.7-1.5 1.2-2.2.6-.6 1.2-1.1 2-1.5.8-.4 1.7-.6 2.6-.6zm0 1.8c-.6 0-1.2.1-1.8.4-.5.3-.9.7-1.2 1.1-.3.5-.6 1-.7 1.6-.2.6-.2 1.2-.2 1.8 0 .6.1 1.2.2 1.8.1.6.4 1.1.7 1.6.3.5.7.9 1.2 1.1 1.1.6 2.5.6 3.6 0 .5-.3.9-.7 1.2-1.1.3-.5.6-1 .7-1.6.2-.6.2-1.2.2-1.8 0-.6-.1-1.2-.2-1.8-.1-.6-.4-1.1-.7-1.6-.3-.5-.7-.8-1.2-1.1-.6-.2-1.2-.4-1.8-.4zm10.7-1.5h3.2l3.6 10.2 3.5-10.2H46v13h-2.2v-10l-3.6 10h-1.9l-3.6-10v10h-2.2v-13zm18.6 0h5.7c.8 0 1.5.1 2.3.4 1 .4 1.7 1.3 2 2.3.2.9.2 1.8 0 2.6-.1.5-.3.9-.7 1.3-.4.4-.8.8-1.3 1-.7.3-1.5.4-2.3.4h-3.5v5H51v-13zm2.3 6.1h3.3c.3 0 .5 0 .8-.1.3-.1.5-.2.7-.4.2-.2.4-.4.5-.6.1-.3.2-.7.2-1 0-.4-.1-.7-.2-1.1-.1-.3-.3-.5-.5-.7-.2-.2-.5-.3-.7-.3-.3-.1-.6-.1-.9-.1h-3.4v4.3zm12.3-6.1h9.4v2H68v3.4h6.6v1.9H68v3.8h7.2v2h-9.5v-13.1zm5.3-3.9h2.5l-2.6 2.6h-1.5l1.6-2.6zm7.4 3.9h10.5v2h-4.1v11h-2.3v-11h-4.1v-2zm14.4 0h9.4v2h-7.1v3.4h6.6v1.9h-6.6v3.8h7.2v2h-9.5v-13.1zm13.8 0h2.4l5.9 9.6v-9.6h2.2v13h-2.4l-5.9-9.6h-.1v9.6h-2.2l.1-13zm24.5 4.1c-.1-.3-.2-.7-.4-1-.2-.3-.4-.6-.7-.8-.3-.2-.6-.4-.9-.5-.4-.1-.8-.2-1.3-.2-.6 0-1.2.1-1.8.4-.5.3-.9.7-1.2 1.1-.3.5-.6 1-.7 1.6-.2.6-.2 1.2-.2 1.8 0 .6.1 1.2.2 1.8.1.6.4 1.1.7 1.6.3.5.7.8 1.2 1.1.6.3 1.2.4 1.8.4.5 0 .9-.1 1.4-.3.4-.2.7-.4 1-.7.3-.3.5-.7.6-1.1.2-.4.3-.9.3-1.3h2.2c0 .7-.2 1.5-.5 2.1-.6 1.3-1.6 2.3-2.9 2.8-1.6.6-3.3.5-4.8-.2-.8-.3-1.4-.8-2-1.5-.5-.6-1-1.4-1.2-2.2-.3-.9-.4-1.7-.4-2.6 0-.9.1-1.8.4-2.6.3-.8.7-1.5 1.2-2.2.6-.6 1.2-1.1 2-1.5.8-.4 1.7-.6 2.6-.6.7 0 1.4.1 2.1.3.6.2 1.2.5 1.7.9s.9.9 1.2 1.4c.3.6.5 1.2.6 1.9l-2.2.1zm6.8-4.1h9.4v2h-7.1v3.4h6.6v1.9h-6.6v3.8h7.2v2h-9.5v-13.1zm15.3 8.7c0 .4.1.9.3 1.3.2.3.4.6.7.9.3.2.6.4 1 .5.4.1.8.2 1.3.1.4 0 .9 0 1.3-.2.3-.1.6-.3.9-.4.2-.2.4-.4.5-.6.1-.2.2-.5.1-.7 0-.4-.1-.8-.3-1.1-.2-.2-.5-.4-.7-.5-.5-.2-1-.3-1.6-.5s-1.4-.3-2.3-.6c-.5-.1-1-.3-1.4-.6-.3-.2-.6-.5-.9-.8-.2-.3-.4-.6-.5-.9-.1-.3-.1-.7-.1-1 0-.6.1-1.2.4-1.7.3-.5.6-.9 1.1-1.2.5-.3 1-.6 1.5-.7.6-.2 1.2-.2 1.7-.2.6 0 1.3.1 1.9.3.6.2 1.1.4 1.6.8s.8.8 1.1 1.3c.3.6.4 1.2.4 1.8h-2.3c0-.7-.3-1.4-.9-1.8-.6-.4-1.3-.5-1.9-.5-.3 0-.6 0-.8.1-.3 0-.5.1-.8.3-.2.1-.4.3-.6.5-.4.6-.3 1.4.2 1.9.3.3.7.5 1.1.6l.6.1 1.1.3 1.2.3.9.2c.4.1.8.3 1.1.6.3.2.6.5.8.8.2.3.4.6.5 1 .1.3.1.7.1 1 0 .7-.1 1.3-.4 1.9-.3.5-.7.9-1.2 1.3-.5.3-1.1.6-1.7.7-1.3.3-2.7.3-4 0-.6-.2-1.2-.5-1.7-.8-.5-.4-.9-.9-1.2-1.4-.3-.7-.5-1.4-.5-2.1l2.4-.3zM2.7 234.7H5v12.9H2.7v-12.9zm10.9 0H16l5.9 9.5v-9.5H24v12.9h-2.3l-5.9-9.4h-.1v9.4h-2.1v-12.9zm19.1 0H38c.9 0 1.8.2 2.6.5.7.3 1.3.8 1.8 1.4.5.6.8 1.3 1 2 .4 1.6.4 3.4 0 5-.2.7-.5 1.4-1 2.1-.5.6-1.1 1.1-1.8 1.4-.8.4-1.7.5-2.6.5h-5.3v-12.9zm2.2 11h2.2c.7 0 1.5-.1 2.2-.4.5-.2 1-.6 1.3-1 .3-.4.5-.9.6-1.5.2-1.2.2-2.4 0-3.6-.1-.5-.3-1-.6-1.5-.3-.4-.8-.8-1.3-1-.7-.3-1.4-.4-2.2-.4h-2.2v9.4zm16.6-11h2.3v7.5c0 .4 0 .9.1 1.3 0 .4.2.8.4 1.2.2.4.5.7.9.9 1.1.5 2.3.5 3.4 0 .4-.2.7-.5.9-.9.2-.4.3-.8.4-1.2 0-.5.1-.9.1-1.3v-7.5h2.3v8.3c0 .7-.1 1.5-.4 2.2-.2.6-.6 1.1-1.1 1.5-.5.4-1.1.7-1.7.9-1.4.4-2.9.4-4.3 0-.6-.2-1.2-.5-1.7-.9s-.8-1-1.1-1.5c-.3-.7-.4-1.4-.4-2.2l-.1-8.3zm20.6 8.6c0 .4.1.9.3 1.3.2.3.4.6.7.9.3.2.6.4 1 .5.4.1.8.2 1.3.2.4 0 .9-.1 1.3-.2.3-.1.6-.2.8-.4.2-.2.4-.4.5-.6.1-.2.1-.5.2-.7 0-.4-.1-.8-.3-1.1-.2-.2-.5-.4-.7-.5-.5-.2-1.1-.4-1.6-.5l-2.2-.6c-.5-.1-.9-.3-1.4-.6-.3-.2-.6-.5-.9-.8-.2-.3-.4-.6-.5-.9-.1-.3-.1-.7-.1-1 0-.6.1-1.2.4-1.7.3-.5.6-.9 1.1-1.2.5-.3 1-.6 1.5-.7.6-.1 1.1-.2 1.7-.2.6 0 1.3.1 1.9.3.6.2 1.1.4 1.6.8 1 .7 1.6 1.9 1.5 3.1h-2.3c0-.7-.3-1.3-.8-1.8-.6-.4-1.2-.5-1.9-.5-.3 0-.5 0-.8.1-.3 0-.5.1-.8.3-.2.1-.4.3-.6.5-.2.2-.2.5-.2.8 0 .4.1.8.4 1.1.3.3.7.5 1.1.6l.6.2 1.1.3 1.2.3.8.2c.4.1.8.3 1.1.5.3.2.6.5.8.8.2.3.4.6.5.9.1.3.2.7.2 1 0 .6-.1 1.3-.4 1.9-.3.5-.7 1-1.2 1.3-.5.3-1 .6-1.6.7-.6.1-1.2.2-1.9.2s-1.4-.1-2.1-.3c-.6-.2-1.2-.4-1.7-.8s-.9-.9-1.2-1.4c-.3-.6-.5-1.3-.4-2.1l2-.2zm14.9-8.6h10.4v1.9h-4.1v10.9H91v-10.9h-4v-1.9zm17.9 0h6.1c1.1-.1 2.3.2 3.2.9.7.6 1.1 1.6 1.1 2.6 0 .5-.1 1-.3 1.5-.1.4-.4.7-.6 1-.2.2-.4.4-.7.5-.2.1-.4.2-.5.2.2 0 .4.1.6.2.2.1.4.3.6.5.2.2.4.5.5.8.1.4.2.8.2 1.3 0 .7.1 1.4.2 2.1.1.5.2.9.5 1.3h-2.4c-.2-.3-.3-.6-.3-.9v-1c0-.5 0-1-.1-1.5 0-.4-.2-.7-.4-1.1-.2-.3-.5-.5-.8-.6-.4-.1-.8-.2-1.3-.2h-3.3v5.3H105l-.1-12.9zm2.3 5.9h3.7c.6 0 1.2-.1 1.6-.5.4-.4.6-1 .6-1.5 0-.3 0-.7-.2-1-.1-.2-.3-.5-.5-.6-.2-.1-.5-.2-.7-.3-.3 0-.6-.1-.8-.1h-3.7v4zm16.4-5.9h2.3v12.9h-2.3v-12.9zm11 0h9.3v1.9h-7v3.4h6.5v1.8h-6.5v3.8h7.1v1.9h-9.4v-12.8zm18.8 8.6c0 .4.1.9.3 1.3.2.3.4.6.7.9.3.2.6.4 1 .5.4.1.8.2 1.3.2.4 0 .9-.1 1.3-.2.3-.1.6-.3.8-.4.2-.2.4-.4.5-.6.1-.2.1-.5.1-.7.1-.4 0-.8-.3-1.1-.2-.2-.5-.4-.7-.5-.5-.2-1.1-.4-1.6-.5l-2.2-.6c-.5-.1-.9-.3-1.4-.6-.3-.2-.6-.5-.9-.8-.2-.3-.4-.6-.5-.9-.1-.3-.1-.7-.1-1 0-.6.1-1.2.4-1.7.3-.5.6-.9 1.1-1.2.5-.3 1-.6 1.5-.7.6-.1 1.1-.2 1.7-.2.6 0 1.3.1 1.9.3.6.2 1.1.4 1.6.8.4.3.8.8 1.1 1.3.3.6.4 1.2.4 1.8H159c0-.7-.3-1.3-.8-1.8-.6-.4-1.2-.5-1.9-.5-.3 0-.5 0-.8.1-.3 0-.5.1-.8.3-.2.1-.4.3-.6.5-.4.6-.3 1.4.2 1.9.3.3.7.5 1.1.6l.6.2 1.1.3 1.2.3.8.2c.4.1.8.3 1.1.5.3.2.6.5.8.8.2.3.4.6.5.9.1.3.1.7.1 1 0 .6-.1 1.3-.4 1.9-.3.5-.7 1-1.2 1.3-.5.3-1.1.6-1.6.7-1.3.3-2.7.3-3.9-.1-.6-.2-1.2-.4-1.7-.8s-.9-.9-1.1-1.4c-.3-.6-.5-1.3-.4-2.1l2.1-.2z",
    fill: "#1f3765"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgOpco2I);
export default __webpack_public_path__ + "static/media/opco2i.78629297f75dbe8981eb5a86916d0fa4.svg";
export { ForwardRef as ReactComponent };